import React, { useState, useEffect } from "react";
import { Table } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { DndContext } from "@dnd-kit/core";
import { restrictToVerticalAxis } from "@dnd-kit/modifiers";
import { MenuOutlined } from "@ant-design/icons";
import {
  arrayMove,
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import menuConfigurationActions from "../../../../redux/menuConfiguration/actions";
import MenuConfigurationMenuEditModal from "./MenuConfigurationMenuEditModal";
const MenuConfigurationMenuItemsTable = ({
  setMenuDataSource,
  searchedValue,
  setSearchedTable,
  filterValue,
  setFilterMenuItems,
  setShowDraggableButton,
  filterMenuItems,
  searchedTable,
  searchedFilterItems,
}) => {
  if (searchedTable !== null && searchedTable.length > 0) {
    searchedTable.forEach((item) => {
      item.myMenu = item.myMenuActive;
      item.myDelivery = item.myMenuActive;
    });
  }

  const dispatch = useDispatch();
  const organizationId = Number(localStorage.getItem("organizationId"));
  const { getMenuItemImage, editMenuItem } = menuConfigurationActions;
  const [record, setRecord] = useState({});
  const [openMenuItemEditModal, setOpenMenuItemEditModal] = useState(false);
  const { menuItems, syncImageInProgress } = useSelector(
    (state) => state.menuConfigurationReducer
  );
  const { menuConfiguration } = useSelector(
    (state) => state.organizationsReducer
  );

  const columns = [
    filterMenuItems !== null
      ? {
          key: "sort",
          width: "30px",
        }
      : { width: "0px" },
    {
      title: "Име",
      dataIndex: "name",
      key: "name",
      width: "170px",
      sorter: (a, b) => a?.name?.localeCompare(b?.name),
    },
    {
      title: "Цена",
      dataIndex: "price",
      key: "price",
      width: "80px",
      sorter: (a, b) => a?.price - b?.price,
      render: (text, record) => <div>{record.price.toFixed(2)} €</div>,
    },
    {
      title: "Описание",
      dataIndex: "information",
      key: "information",
      width: "220px",
      responsive: ["sm"],
      render: (text, record) => (
        <div style={{ fontSize: "13px" }}>
          {record.information?.length < 43
            ? record.information
            : record.information?.substring(0, 43).concat("...")}
        </div>
      ),
    },
    {
      title: "Грамаж",
      dataIndex: "menuText",
      key: "menuText",
      width: "70px",
      responsive: ["sm"],
    },

    {
      title: "Група",
      dataIndex: "menuCategoryName",
      key: "menuCategoryName",
      width: "170px",
      sorter: (a, b) => a?.menuCategoryName?.localeCompare(b?.menuCategoryName),
    },
    {
      title: "Сорт Индекс",
      dataIndex: "itemSortIndex",
      key: "itemSortIndex",
      width: "50px",
      render: (text, record) => <div>{record.itemSortIndex}</div>,
    },
    {
      title: "MyMenu",
      dataIndex: "myMenu",
      key: "myMenu",
      width: window.innerWidth > 760 ? "80px" : "120px",

      filters: [
        {
          text: "да",
          value: 1,
        },
        {
          text: "не",
          value: 0,
        },
      ],
      render: (text, record) => (
        <div>
          {record.myMenu === 0 && "не"}
          {record.myMenu === 2 && "не"}
          {record.myMenu === 1 && "да"}
          {record.myMenu === 3 && "да"}
        </div>
      ),
      onFilter: (value, record) =>
        (record?.myMenu === 0 || record?.myMenu === 2 ? 0 : 1) === value,
    },
    menuConfiguration?.deliveryEnabled
      ? {
          title: "MyDelivery",
          dataIndex: "myDelivery",
          key: "myDelivery",
          width: window.innerWidth > 760 ? "85px" : "120px",

          filters: [
            {
              text: "да",
              value: 1,
            },
            {
              text: "не",
              value: 0,
            },
          ],
          render: (text, record) => (
            <div>
              {record.myDelivery === 0 && "не"}
              {record.myDelivery === 2 && "да"}
              {record.myDelivery === 1 && "не"}
              {record.myDelivery === 3 && "да"}
            </div>
          ),
          onFilter: (value, record) =>
            (record?.myDelivery === 0 || record?.myDelivery === 1 ? 0 : 1) ===
            value,
        }
      : {
          width: "0px",
        },
  ];

  useEffect(() => {
    setMenuDataSource(menuItems);

    if (searchedValue === null) {
      setSearchedTable(menuItems);
    } else {
      setSearchedTable(
        menuItems.filter((o) =>
          Object.keys(o).some((k) => {
            return String(o[k])
              .toLowerCase()
              .includes(searchedValue.toLowerCase());
          })
        )
      );
    }

    if (filterValue !== "Всички") {
      setFilterMenuItems(
        menuItems.filter((item) => item.menuCategoryName === filterValue)
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [menuItems]);

  useEffect(() => {
    if (filterValue === "Всички") {
      setFilterMenuItems(null);
      setShowDraggableButton(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterValue]);

  const Row = ({ children, ...props }) => {
    const {
      attributes,
      listeners,
      setNodeRef,
      setActivatorNodeRef,
      transform,
      transition,
      isDragging,
    } = useSortable({
      id: props["data-row-key"],
    });
    const style = {
      ...props.style,
      transform: CSS.Transform.toString(
        transform && {
          ...transform,
          scaleY: 1,
        }
      ),
      transition,
      ...(isDragging
        ? {
            position: "relative",
            zIndex: 9999,
          }
        : {}),
    };
    return (
      <tr {...props} ref={setNodeRef} style={style} {...attributes}>
        {React.Children.map(children, (child) => {
          if (child.key === "sort") {
            return React.cloneElement(child, {
              children: (
                <MenuOutlined
                  ref={setActivatorNodeRef}
                  style={{
                    touchAction: "none",
                    cursor: "move",
                  }}
                  {...listeners}
                />
              ),
            });
          }
          return child;
        })}
      </tr>
    );
  };

  const onDragEnd = ({ active, over }) => {
    if (active.id !== over?.id) {
      setFilterMenuItems((previous) => {
        const activeIndex = previous.findIndex((i) => i.itemId === active.id);
        const overIndex = previous.findIndex((i) => i.itemId === over?.id);
        const sortedData = arrayMove(previous, activeIndex, overIndex);
        const updatedData = [...sortedData];
        const updatedMenuItem = previous.at(activeIndex);
        const overMenuItem = previous.at(overIndex);

        dispatch(
          editMenuItem({
            item: {
              itemId: updatedMenuItem.itemId,
              name: updatedMenuItem.name,
              menuText: updatedMenuItem.menuText,
              information: updatedMenuItem.information,
              kcal: updatedMenuItem.kcal,
              itemSortIndex: overMenuItem.itemSortIndex,
              menuCategoryId: updatedMenuItem.menuCategoryId,
              myMenuActive: updatedMenuItem.myMenuActive,
              image: updatedMenuItem.image,
            },
            organizationId,
          })
        );
        return updatedData;
      });
    }
  };

  function replaceKeyRecursive(obj) {
    if (Array.isArray(obj)) {
      obj.sort((a, b) => {
        // If sortIndex is 0, move it to the end
        if (a.sortIndex === 0 && b.sortIndex !== 0) {
          return 1;
        } else if (a.sortIndex !== 0 && b.sortIndex === 0) {
          return -1;
        } else {
          // Otherwise, sort by sortIndex in ascending order
          return a.sortIndex - b.sortIndex;
        }
      });

      return obj.map((item) => replaceKeyRecursive(item));
    } else {
      return obj;
    }
  }

  // Replace subCategories with children for And Design Table component
  const data = replaceKeyRecursive(
    filterMenuItems === null
      ? searchedTable
      : searchedFilterItems === null
      ? filterMenuItems
      : searchedFilterItems
  );

  return (
    <>
      <DndContext modifiers={[restrictToVerticalAxis]} onDragEnd={onDragEnd}>
        <SortableContext
          items={
            filterMenuItems !== null
              ? filterMenuItems
                  ?.sort((a, b) => b.itemSortIndex - a.itemSortIndex)
                  ?.map((i) => i.itemId)
              : []
          }
          strategy={verticalListSortingStrategy}
        >
          <Table
            components={{
              body: {
                row: Row,
              },
            }}
            className="menu-configuration-menu-items-table"
            loading={menuItems.length === 0 || syncImageInProgress}
            dataSource={data}
            pagination={{
              defaultPageSize: 50,
              showSizeChanger: true,
              pageSizeOptions: ["10", "25", "50", "100"],
            }}
            size="small"
            rowKey="itemId"
            columns={columns}
            onRow={(record) => ({
              onClick: () => {
                setRecord(record);
                setOpenMenuItemEditModal(true);
                dispatch(getMenuItemImage(organizationId, record?.itemId));
              },
            })}
          />
        </SortableContext>
      </DndContext>
      <MenuConfigurationMenuEditModal
        record={record}
        openMenuItemEditModal={openMenuItemEditModal}
        setOpenMenuItemEditModal={setOpenMenuItemEditModal}
      />
    </>
  );
};

export default MenuConfigurationMenuItemsTable;
